/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument */
import axios from "axios";

export class CodeInputGroup {
	private readonly codeInput: JQuery;
	private readonly errorMessage: JQuery;
	private readonly applyCodeButton: JQuery;
	private loading = false;

	constructor(containerId: DOMElementIdentifier, _constructionParameters: ConstructionParameters) {
		const group = jQuery("#" + containerId);

		group.on("resetCodeInputGroup", this.onReset.bind(this));

		this.codeInput = group.find(".mia-codeInput");
		this.errorMessage = group.find(".mia-message");

		this.applyCodeButton = group.find(".mia-applyButton");
		this.applyCodeButton.on("click", (event) => void this.onApplyCodeButtonClick(event));

		this.codeInput.on("keypress", (event) => {
			if (event.keyCode === 13) {
				event.preventDefault();
				this.applyCodeButton.trigger("click");
			}
		});
	}

	private onReset(_event: JQuery.Event) {
		this.hideMessage();
		this.codeInput.val("");
	}

	private async onApplyCodeButtonClick(event: JQuery.Event): Promise<void> {
		event.preventDefault();

		const code = this.codeInput.val();

		if (!code) {
			this.showMessage(this.codeInput.data("error-empty"), false);
			return;
		}

		if (this.loading) {
			return;
		}

		this.loading = true;
		this.applyCodeButton.button("loading");

		const url = this.applyCodeButton.data("url").replace("PLH_code", code);
		try {
			const { data } = await axios.get(url);
			this.onApplyCodeSucceeded(data);
		}
		finally {
			this.applyCodeButton.button("reset");
			this.loading = false;
		}
	}

	private showMessage(message: string, success: boolean) {
		this.errorMessage.html(message);
		this.errorMessage.addClass(success ? "success" : "error");
		this.errorMessage.show();
	}

	private hideMessage() {
		this.errorMessage.hide();
		this.errorMessage.removeClass("error");
		this.errorMessage.removeClass("success");
	}

	private onApplyCodeSucceeded(data: any): void {
		this.hideMessage();

		if (data.success) {
			if (data.redirectUrl) {
				window.location.href = data.redirectUrl;
			}
			if (data.successMessage) {
				this.showMessage(data.successMessage, true);
			}
			if (data.updatePurchaseSummary) {
				this.updatePurchaseSummary();
			}
			if (data.updateProductSelector) {
				this.updateProductSelector();
			}
		}
		else {
			this.showMessage(data.errorMessage, false);
		}
	}

	private updateProductSelector() {
		const productSelector = jQuery(".mia-ProductSelector");
		productSelector.trigger("updateProductSelector");
	}

	private updatePurchaseSummary() {
		const purchaseSummary = jQuery(".mia-PurchaseSummary");
		purchaseSummary.trigger("updatePurchaseSummary");
	}
}
